<template>
    <div id="history">
        <Banner title="學會沿革" :breadcrumbs="breadcrumbs" type="society"></Banner>
        <div class="container learning">
            <div class="center_title">
                <Title en="Learning evolution" chtFirst="學會" chtSecond="沿革" :center="true"></Title>
            </div>
            <Language @getLanguage="myLanguage"></Language>
            <section class="content">
                <div class="title">{{Language.title}}</div>
                <div class="img">
                    <img :src="img" alt="理事長a圖" />
                </div>
                <div class="list" v-for="(p,index) in Language.content" :key="index">
                    <div class="subtitle">{{p.subtitle}}</div>
                    <p>{{p.description}}</p>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Language from "@/components/switchLanguage";
export default {
    name: "history",
    components: {
        Language
    },
    props: {},
    data() {
        return {
            breadcrumbs: [
                {
                    url: "/",
                    title: "首頁"
                },
                {
                    title: "學會簡介"
                },
                {
                    url: "/Society/Index",
                    title: "學會沿革"
                }
            ],
            Language: {},
            img: require("@/assets/info/person.png"),
            cht: {
                title: "劉榮宏 榮譽理事長的話",
                content: [
                    {
                        subtitle: "緣起",
                        description:
                            "這幾年每次和一些熱心視網膜治療的同道醫師會議聚會時，大家總會興起成立視網膜學會的念頭和話題，尤其在出國開會時更會如此。因為許多醫學先進大國都已建立視網膜學會，而台灣還沒有。我們可以設立一個專業的視網膜學會的好處，是我們可以更密集落實的交流互動。從各式的研討會討、論會中多學習、求新、求進步、堤身品質水準。更有可能由學會的調整配合得到更多的院際合作計畫，還有可能方便與國際接軌，建立通路窗口，爭取主辦國際視網膜會議。在100年4月間的一次小聚會中，徵求到7位同仁自願擔任原始發起人(林嘉理醫師、楊中美醫師、李鳳利醫師、吳文權醫師、陳立仁醫師、陳建同醫師及本人)，並號召共同發起人共44位。6月間我們將申請書及發起人名冊送至內政部，8月間接獲內政部通知審查通過，同意成立籌備會及訂期成立大會。10月初由發起人會中選舉籌備委員，在兩次的籌備委員會中，敲定章程草案，會員資格及審查入會會員，並決定大會成立日期。會員大會在101年1月8日舉行，籌備會同時解散。這一天也是中華民國視網膜醫學會的成立日。"
                    },
                    {
                        subtitle: "創會宗旨、任務",
                        description:
                            "創會宗旨、任務在第一屆會員大會中，逐條審閱通過本會章程草案，及通過年度工作計畫、收支預算及籌備會經費收支報告案。	開宗明義，我們通過的宗旨是：整合視網膜醫學會及研究人才，提昇國內醫療水準。促進學術合作，推動視網膜醫學之國際交流。至於現階段之任務是：發行本國視網膜醫學刊物，舉辦視網膜醫學之學術演講及研討會，整合視網膜研究及提供臨床知識交流平台。由此上宗旨和任務的宣言，我們知道本學會全體同仁未來的工作目標和努力的方向。"
                    },
                    {
                        subtitle: "工作團隊的產生",
                        description:
                            "今年1月8日第一次會員大會中，我們選出15位理事及5位監事(名單見封面內頁)，皆為國內視網膜界之翹楚領導人物。中午第一次理監事會中再選出常務理事：楊中美醫師、林嘉理醫師、許淑娟醫師、陳建同醫師、劉榮宏醫師及常務監事文良彥醫師。另組成學術委員會、教育委員會、國際及兩岸交流事務委員會、編輯委員會。並敦請楊中美理事為學術委員會召集人、賴旗俊理事、許淑娟理事為學術共同召集人，林嘉理理事為教育委員會召集人，吳文權理事、李鳳利理事為教育共同召集人，賴旗俊理事為國際及兩岸交流事務委員會召集人，楊中美理事及許淑娟理事為共同召集人。陳建同理事為編輯委員會召集人，許淑娟理事、陳立仁里事是編輯共同召集人。各委員會委員由召集人和共同召集人共商；就理監事及會員中選取編列。令任命趙效明醫師為秘書長，黃奕修醫師、吳佩昌醫師為共同秘書長。相信這組合將會是一個具高度執行力和創造力的團隊。"
                    },
                    {
                        subtitle: "期許",
                        description:
                            "今年度視網膜醫學會將發行４期的會訊。會訊中將包括學會活動報告、專題討論、焦點資訊、新知報告、病例共享等。本學會將舉辦演講及討論會，除了參加教授學會在大會中共同舉辦視網膜研討會，另推出以視網膜為主的兩場討論會。我們除參加國內母學會（中華民國眼科學會）的年會、地方醫學會各項會議活動外，並參加國外有關視網膜之重要會議。創會之初，一切事務進行會較緩慢，但會員在群策群力，共同努力下，一定可以達成目標，完成使命，讓我們共勉。同時我們也期待更多有興趣於視網膜的眼科同仁一起來加入這個行列，共襄盛舉！"
                    }
                ]
            },
            en: {
                title: "Establishing the Taiwan Retinal Society",
                content: [
                    {
                        subtitle: "Origin",
                        description:
                            "The idea of establishing an organization for retinal specialists has been raised many times in recent years when our retinal surgeons have met, particularly at overseas meetings.Many medically advanced countries had already established such retinal societies, while Taiwan has not. The benefits of establishing an organization which focuses purely on retinal medicine will provide us with better and more frequent interactions with fellow surgeons and experts in the field. Through seminars and symposiums, we will be able to learn more, pursue new ideas, and make progress. It will help us to improve the standard and quality of our services. Through the academic organization to establish inter-hospital cooperation programs; it will also help us to synchronize with our peers internationally, building contacts and bidding to host international meetings for retinal specialists.In a gathering in April 2011, seven specialists volunteered to be the originators to establish the society, (Dr. Lin, Chia-Li, Dr. Yang, Chung-May, Dr. Lee, Feng-Lih, Dr. Wu, Wen-Chung, Dr. Chen, Lee-Jen, Dr. Chen, Jiann-Torng, and myself.) and inviting a further 44 co-originators to join us. We sent the application and list of founders to the Ministry of the Interior in June, and approval was granted in August. We then agreed to set up the preparatory committee and regular meetings. In early October, the members of the preparatory committee were elected during the originators’ meeting. In the two meetings of the committee, we finalized the draft constitution, membership requirements, reviewed applications, and decided the date for official establishment of the society. On January 8th 2012, the preparatory committee was dismissed as the first full committee meeting was held, marking the establishment of the Taiwan Retina Society."
                    },
                    {
                        subtitle: "Purpose and Mission",
                        description:
                            "At the first General Assembly, we reviewed the draft constitution clause-by-clause, and passed it alongside the annual plan, budget, and preparatory committee revenue and expenditure report.The primary purposes that we have passed are: to enhance the standard of practice in Taiwan through facilitating the interaction of medical specialists and academic researchers, and to promoted academic exchange with our international colleagues.Currently, our tasks are: to issue a national publication specializing in retinal medicine; to organize lectures and seminars; to integrate medical research in the field; and to provide a platform for the exchange of clinical expertise.Base on the primary purposes, we intend to work together with our members to achieve our stated intentions."
                    },
                    {
                        subtitle: "Establishment of the team.",
                        description:
                            "During the first General Assembly on January 8th of this year, we selected 15 directors and 5 supervisors by vote (see the list on inside front cover), all of whom are leading pioneers in the field of retinal medicine. At the first meeting of the Board of Directors and Supervisors, at noon, we also selected the Executive Directors Dr. Yang, Chung-May, Dr. Lin, Chia-Li, Dr. Sheu, Shwu-Jiuan, Dr. Chen, Jiann-Torng, and Dr. Liu, Jorn-Hon and Executive Supervisor Dr. Wen, Liang Yen. We also set up the Academic Committee, Education Committee, International and Cross-Strait Affair Committee, and Editorial Committee. Director Yang, Chung-May was appointed as the convener of the Academic Committee with Director Lai, Chi-Chun and Director Sheu, Shwu-Jiuan as deputy conveners; Director Lin, Chia-Li as the convener of the Education Committee, with Director Wu, Wen-Chung and Director Lee, Feng-Lih as deputy conveners; Director Lai, Chi-Chun as the convener of the International and Cross-Strait Committee, with Director Yang, Chung-May and Director Sheu, Shwu-Jiuan as deputy conveners; Director Chen, Jiann-Torng as the convener of the Editorial Committee, with Director Sheu, Shwu-Jiuan and Director Chen, Lee-Jen as the deputy conveners. The conveners and deputy conveners select each committee’s members from the list of supervisors and members. Dr. Chao, Hsiao-Ming was appointed as Secretary General, with Dr. Hwang, Yih-Shiou and Dr. Wu, Pei-Chan as the Deputy Secretary Generals. I believe this combination will form a highly effective and creative team."
                    },
                    {
                        subtitle: "Intentions",
                        description:
                            "The Taiwan Retina Society will issue four journals this year. The journals will include reports on academic events, panel discussions, hotspot news, new findings, and clinical case studies. The Society will hold lectures and seminars. In addition to participating at the Taiwan Association of University Professors, where we will organize a seminar in the General Assembly, we will present two further seminars. We are not only talking part in the General Assembly of the Ophthalmological Society of Taiwan, and meetings held by local medical associations, but also attending important events abroad.At the beginning of the founding, all affairs might be carried out a bit slowly, but through the combined efforts of our members, we will no doubt succeed in fulfilling our aims. We look forward to having more people join us as we work together on this great project."
                    }
                ]
            }
        };
    },
    methods: {
        myLanguage(e) {
            this.Language = this[e];
            // console.log(this.Language);
        }
    },
    computed: {},
    created() {
        this.Language = this.cht;
    },
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#history .content .img {
    width: 200px;
    font-size: 0;
    margin: auto;
}
#history .content .img img {
    width: 100%;
}
#history .content .list {
    padding: 20px 0;
}

#history .content .list .subtitle {
    font-size: 36px;
    font-weight: 600;
    text-align: center;
    padding: 10px 0;
    margin-bottom: 20px;
}

@media screen and (max-width: 767px) {
    #history .content .title {
        font-size: 22px;
    }
    #history .content .img {
        width: 100%;
    }
    #history .content .list .subtitle {
        font-size: 28px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/history.vue